module.exports = __webpack_public_path__ + "static/media/clouds-transparent.d094a0ed.png";